import { Component, AfterViewInit, ElementRef, ViewChild, ViewEncapsulation, OnInit, Input } from '@angular/core';
import { FormBroadcast, FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';
import { PlanUtilityService } from 'src/app/angular-elements/plan-selection/plan-summary-list/plan-utility.service';
import { PlansStateStructure } from 'src/app/angular-elements/plan-selection/configs/interfaces/plansStateStructure.interface';
import { Product } from 'src/app/angular-elements/plan-selection/interfaces/product.interface';
import { PlanAttributes, SummaryView } from 'src/app/angular-elements/plan-selection/interfaces/plan-attributes.interface';
import { SeniorMarketsEnrollmentSubmissionService } from 'src/app/angular-elements/shared/services/enrollment/senior-markets/enrollment-submission.senior-markets';

//import * as moment from 'moment';
import moment from 'moment';
import { ConfirmationPageUrls } from 'src/app/angular-elements/shared/components/interfaces/confirmation-page-urls.interface';
import { DateService } from '../../../../shared/services/date.service';
import { PrePopulatedDataStateStructure } from '../../../shared/components/configs/interfaces/prePopulatedDataStateStructure.interface';


@FormComponentLookup('applicant-info-review')
@Component({
    selector: 'app-applicant-info-review',
    templateUrl: './applicant-info-review.component.html',
    styleUrls: ['./applicant-info-review.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class ApplicantInfoReviewComponent extends FormEntryComponentClass implements AfterViewInit {

  @ViewChild('entryRef') entryRef: ElementRef;

  @Input() confirmationPageUrls: ConfirmationPageUrls;

  isSubmitting = false;
  value: any = [];
  submittedApplicantName: string;
  effectiveDate: string;
  medicareNumber: string;
  billingInformation: string;
  monthlyPremium: string;
  pcpCoPay: string;

  plans: PlansStateStructure;
  product: string;

  constructor(
    private commonUtilityService: CommonUtilityService,
    private planUtilityService: PlanUtilityService,
    private reducerUtilService: ReducerUtilityService,
    private dateUtility: DateService
  ) {
    super();

    this.plans = this.reducerUtilService.getState('Plans')
  }

  ngOnInit() {
    if (this.entry && this.entry.custom && this.entry.custom.values) {
      if (this.entry.custom.values.valuesFromState) {
        for (const obj of this.entry.custom.values.valuesFromState) {
          const payload = this.reducerUtilityService.getPayloadStates();
          const dataParsed = this.commonUtilityService.setNestedProperty(payload, this.entry.formControlAttributes.connectPath, "IndividualPageReview");
          this.value.push(dataParsed[obj]);
        }
        if (this.entry.custom.values.valueFromSystem === "sysdate") {
          this.value.push(moment().format('MM/DD/YYYY'));
        }
      }
    }
  }

  ngAfterViewInit(): void {
    this.initTriggers();

    this.initSubmitStatusListener();
  }

  initTriggers() {
    const payloadState = JSON.parse(JSON.stringify(this.reducerUtilityService.getPayloadStates()));
    const enrollmentData = payloadState.enrollment;
    const personalInfo = payloadState.personalInfo;
    const plansFromState = this.planUtilityService.getPlansByProductGroupAsArray();

    let selectedPlan: Product<PlanAttributes, SummaryView> = plansFromState.filter(plan => plan?.attributes?.PLAN_ID === this.plans?.planIdForEnrollment)[0];
    this.product = selectedPlan?.attributes?.PRODUCT_NAME;

    if (this.plans.isPlanChange) {
      const prePopulateData: PrePopulatedDataStateStructure = this.reducerUtilService.getState('PrePopulateData');
      this.medicareNumber = prePopulateData.prepopulatedFields.memberLookup.HICNUMBER;
      this.submittedApplicantName = prePopulateData.prepopulatedFields.firstName + ' ' + prePopulateData.prepopulatedFields.lastName;
    }
    else {
      this.medicareNumber = enrollmentData.medicareNumber;
      this.submittedApplicantName = personalInfo.firstName + ' ' + personalInfo.lastName;
    }

    if (enrollmentData.effectiveDate) {
      this.effectiveDate = this.dateUtility.getEffectiveDate(enrollmentData.effectiveDate);
    }

    if (enrollmentData.billingFrequency === 'M') {
      this.billingInformation = "monthly";
    } // need to information from backend how they are decoding and then update here.

    let billingInfo = '';
    // Billing Frequency and billing information
    switch (enrollmentData.billingFrequency) {
      case "M":
        billingInfo = "Monthly";
        break;
      case "Q":
        billingInfo = "Quarterly";
        break;
      case "S":
        billingInfo = "Semi-Annually";
        break;
      case "A":
        billingInfo = "Annually";
        break;
    }
    if (enrollmentData.paymentType === 'S') {
      billingInfo = "Social Security (SSA) Benefit Check";
    } else if (enrollmentData.paymentType === 'R') {
      billingInfo = "Railroad Retirement Board (RRB) benefit check";
    }

    this.billingInformation = billingInfo;
    this.pcpCoPay = this.getPcpCopay(selectedPlan);
    this.monthlyPremium = Number(selectedPlan.price).toFixed(2);
  }

  onSubmit() {
    const event: FormBroadcast = {
      formControlName: 'applicant-info-review',
      type: 'submit-app',
      value: 'submit'
    };

    this.formStreamTrigger.triggerFormStream(event);
  }

  initSubmitStatusListener() {
    this.subscriptionGroup.push(
      this.formStreamTrigger.subscribeToFormStream((event) => {
        if (event.type === 'submit-locked') {
          this.isSubmitting = event.value;
        }
      })
    );
  }

  getPcpCopay(selectedPlan: Product<PlanAttributes, SummaryView>): string {
    if (!selectedPlan.summaryView?.benefits?.length) {
      return '0';
    }

    let pcpCopay = selectedPlan.summaryView.benefits.filter((benefit) => { benefit.key === 'PCP Copay'})[0];

    return pcpCopay?.value?.split(' ')[0];
  }
}
